import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
} from "@mui/material";
import { Box } from "@mui/system";
import { DataGridPro, GridColDef } from "@mui/x-data-grid-pro";

// --- rows (your JSON data) ---
const rows = [
  {
    id: 1,
    searchTerm: "best betting",
    matchType: "Exact",
    negativeLevel: "Adgroup",
    lastSeen: "01/07/25",
    hImp: "12,000",
    hClicks: "4,700",
    hCost: "12,000$",
  },
  {
    id: 2,
    searchTerm: "betting sites uk",
    matchType: "Exact",
    negativeLevel: "Adgroup",
    lastSeen: "08/07/25",
    hImp: "300",
    hClicks: "30",
    hCost: "300$",
  },
  {
    id: 3,
    searchTerm: "sports betting",
    matchType: "Broad",
    negativeLevel: "Adgroup",
    lastSeen: "13/07/25",
    hImp: "7,800",
    hClicks: "7,800",
    hCost: "7,800$",
  },
  {
    id: 4,
    searchTerm: "best betting sites",
    matchType: "Exact",
    negativeLevel: "Adgroup",
    lastSeen: "17/07/25",
    hImp: "10,400",
    hClicks: "7,800",
    hCost: "213,456$",
  },
  {
    id: 5,
    searchTerm: "UK sports betting",
    matchType: "Broad",
    negativeLevel: "Adgroup",
    lastSeen: "21/07/25",
    hImp: "213,456",
    hClicks: "12,000",
    hCost: "300$",
  },
  {
    id: 6,
    searchTerm: "best betting uk",
    matchType: "Broad",
    negativeLevel: "Adgroup",
    lastSeen: "01/07/25",
    hImp: "12,000",
    hClicks: "1,000",
    hCost: "7,800$",
  },
  {
    id: 7,
    searchTerm: "sport gambling",
    matchType: "Broad",
    negativeLevel: "Adgroup",
    lastSeen: "08/07/25",
    hImp: "300",
    hClicks: "43",
    hCost: "300$",
  },
  {
    id: 8,
    searchTerm: "betting",
    matchType: "Exact",
    negativeLevel: "Adgroup",
    lastSeen: "13/07/25",
    hImp: "7,800",
    hClicks: "30",
    hCost: "7,800$",
  },
  {
    id: 9,
    searchTerm: "online betting sites",
    matchType: "Broad",
    negativeLevel: "Adgroup",
    lastSeen: "17/07/25",
    hImp: "10,400",
    hClicks: "7,800",
    hCost: "213,456$",
  },
  {
    id: 10,
    searchTerm: "top sports betting",
    matchType: "Exact",
    negativeLevel: "Adgroup",
    lastSeen: "21/07/25",
    hImp: "213,456",
    hClicks: "7,800",
    hCost: "300$",
  },
];

const NegeativeST = ({ open, rowData, onClose }: any) => {
  // --- Define columns ---
  const columns: GridColDef[] = [
    { field: "searchTerm", headerName: "Search Term", flex: 1, minWidth: 160 },
    { field: "matchType", headerName: "Match Type", flex: 0.6, minWidth: 110 },
    {
      field: "negativeLevel",
      headerName: "Negative Level",
      flex: 0.8,
      minWidth: 140,
    },
    { field: "lastSeen", headerName: "Last Seen", flex: 0.6, minWidth: 110 },
    { field: "hImp", headerName: "H.IMP", flex: 0.6, minWidth: 110 },
    { field: "hClicks", headerName: "H.Clicks", flex: 0.6, minWidth: 110 },
    { field: "hCost", headerName: "H.Cost", flex: 0.6, minWidth: 110 },
  ];
  if (!rowData) return null;

  return (
    <Dialog open={open} onClose={onClose} maxWidth="lg" fullWidth>
      <DialogTitle>Other Keywords</DialogTitle>
      <DialogContent>
        <Box sx={{ width: "100%", display: "grid", mt: 1 }}>
          <DataGridPro
            sx={{
              "& .MuiDataGrid-cell:focus, & .MuiDataGrid-cell:focus-within": {
                outline: "none",
              },
              "& .MuiDataGrid-columnHeader:focus, & .MuiDataGrid-columnHeader:focus-within":
                { outline: "none" },
              "& .MuiDataGrid-cellEmpty": {
                width: "auto",
                overflow: "hidden",
                textOverflow: "ellipsis",
              },

              // row selection only once
              "& .MuiDataGrid-row.Mui-selected": {
                backgroundColor: "rgba(156, 39, 176, 0.08) !important",
                "&:hover": {
                  backgroundColor: "rgba(156, 39, 176, 0.16) !important",
                },
              },

              "& .MuiDataGrid-row.Mui-selected .MuiDataGrid-cell--pinnedLeft": {
                backgroundColor: "#f0def3 !important",
              },
              "& .MuiDataGrid-row.Mui-selected:hover .MuiDataGrid-cell--pinnedLeft":
                {
                  backgroundColor: "#e6d6e9ff !important",
                },

              // pinned RIGHT
              "& .MuiDataGrid-row.Mui-selected .MuiDataGrid-cell--pinnedRight":
                {
                  backgroundColor: "#f0def3 !important",
                },
              "& .MuiDataGrid-row.Mui-selected:hover .MuiDataGrid-cell--pinnedRight":
                {
                  backgroundColor: "#e6d6e9ff !important",
                },
              // make pinned cells transparent → let row bg show through
              "& .MuiDataGrid-cell--pinnedLeft, & .MuiDataGrid-cell--pinnedRight":
                {
                  backgroundColor: "#ffffff",
                },

              // remove extra blue tint on single cell select
              "& .MuiDataGrid-cell.Mui-selected": {
                backgroundColor: "inherit !important",
              },

              "& .MuiCheckbox-root": {
                color: "#9c27b0 !important",
              },
              "& .MuiCheckbox-root.Mui-checked": {
                color: "#9c27b0",
              },
              border: "none",
            }}
            density="compact"
            hideFooter
            pagination={false}
            rows={rows}
            columns={columns}
            disableColumnMenu
            disableColumnFilter
            disableColumnReorder
            sortingOrder={["asc", "desc"]}
            isCellEditable={() => false}
            disableRowSelectionOnClick
          />
        </Box>
      </DialogContent>
      <DialogActions sx={{ padding: "16px 20px 16px" }}>
        <Button onClick={onClose} color="secondary" variant="outlined">
          Cancel
        </Button>
        <Button variant="contained" onClick={onClose} color="secondary">
          Confirm
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default NegeativeST;
